// extracted by mini-css-extract-plugin
export default {"actions":"Cajas_actions__jKfiQ","abierta":"Cajas_abierta__sUPeo","descuadre":"Cajas_descuadre__Kywq9"};